export const TEACHER_COMMENT_ATTRIBUTE = "data-teacher-comment";
export const TEACHER_DELETION_VALUE = "deletion";

export type TeacherCommentCorrection = {
  id: string;
  start: number;
  length: number;
  text: string;
  kind?: "deletion";
};

const quillInsertLength = (insert: unknown) => {
  return typeof insert === "string" ? insert.length : 1;
};

export const useTeacherCommentCorrections = (
  ops: unknown = []
): TeacherCommentCorrection[] => {
  // Older or incomplete revisions can contain a non-array placeholder.
  if (!Array.isArray(ops)) return [];

  const corrections: TeacherCommentCorrection[] = [];
  let position = 0;
  let activeCorrection: TeacherCommentCorrection | undefined;

  const finishActiveCorrection = () => {
    if (activeCorrection == undefined) return;

    if (activeCorrection.text.trim().length > 0) {
      corrections.push(activeCorrection);
    }

    activeCorrection = undefined;
  };

  for (const op of ops) {
    const length = quillInsertLength(op?.insert);
    const isDeletion = op?.attributes?.[TEACHER_COMMENT_ATTRIBUTE] === TEACHER_DELETION_VALUE;
    const isTeacherComment =
      isDeletion ||
      op?.attributes?.[TEACHER_COMMENT_ATTRIBUTE] === true ||
      op?.attributes?.[TEACHER_COMMENT_ATTRIBUTE] === "true";

    if (!isTeacherComment) {
      finishActiveCorrection();
      position += length;
      continue;
    }

    // A crossed-out passage and a neighboring comment are separate suggestions.
    if (activeCorrection && (activeCorrection.kind === "deletion") !== isDeletion) {
      finishActiveCorrection();
    }

    if (activeCorrection == undefined) {
      activeCorrection = {
        id: `${position}-${length}`,
        start: position,
        length: 0,
        text: "",
        ...(isDeletion ? { kind: "deletion" as const } : {}),
      };
    }

    activeCorrection.length += length;
    if (typeof op.insert === "string") {
      activeCorrection.text += op.insert;
    }

    position += length;
  }

  finishActiveCorrection();

  return corrections;
};
